import { Navigate, useParams } from "react-router-dom";

const ReferralPage=()=>{
    const { referral_id } = useParams();

    return <Navigate to={`/signup/${referral_id || ''}`} replace={true} />;

}


export default ReferralPage;